export default __webpack_public_path__ + "static/media/right_arrow.2d7762bc.svg";